import React from "react";
import { useNavigate } from "react-router-dom";
import useLoginStore from "@/stores/loginStore";
import { Avatar } from "@/components/avatar";
import {
  Dropdown,
  DropdownButton,
  DropdownDivider,
  DropdownItem,
  DropdownLabel,
  DropdownMenu,
} from "@/components/dropdown";
import {
  Navbar,
  NavbarItem,
  NavbarSection,
  NavbarSpacer,
} from "@/components/navbar";
import {
  Sidebar,
  SidebarBody,
  SidebarHeader,
  SidebarItem,
  SidebarLabel,
  SidebarSection,
} from "@/components/sidebar";
import { StackedLayout } from "@/components/stacked-layout";
import {
  ArrowRightStartOnRectangleIcon,
  DocumentTextIcon,
} from "@heroicons/react/16/solid";

interface StudentPageContainerProps {
  children: React.ReactNode;
}

// 학생 네비게이션 항목 - My Exams만 남깁니다
const navItems = [
  { label: "My Exams", url: "/my_exams", icon: <DocumentTextIcon /> },
];

const StudentPageContainer: React.FC<StudentPageContainerProps> = ({
  children,
}) => {
  const navigate = useNavigate();
  const { clearToken } = useLoginStore();

  const handleLogout = () => {
    clearToken();
    navigate("/login");
  };

  return (
    <StackedLayout
      navbar={
        <Navbar>
          <NavbarItem href="/my_exams" className="font-bold text-xl">
            S&S Academy
          </NavbarItem>
          <NavbarSpacer />
          <NavbarSection>
            <NavbarItem href="/my_exams">My Exams</NavbarItem>
            <Dropdown>
              <DropdownButton as={NavbarItem}>
                <Avatar initials="S" className="bg-blue-500 text-white" />
              </DropdownButton>
              <DropdownMenu className="min-w-64" anchor="bottom end">
                <DropdownItem onClick={handleLogout}>
                  <ArrowRightStartOnRectangleIcon />
                  <DropdownLabel>Sign out</DropdownLabel>
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </NavbarSection>
        </Navbar>
      }
      sidebar={
        <Sidebar>
          <SidebarHeader>
            <SidebarItem className="lg:mb-2.5">
              <Avatar initials="S" className="bg-blue-500 text-white" />
              <SidebarLabel>Student Portal</SidebarLabel>
            </SidebarItem>
          </SidebarHeader>
          <SidebarBody>
            <SidebarSection>
              {navItems.map(({ label, url, icon }) => (
                <SidebarItem key={label} href={url}>
                  {icon}
                  <SidebarLabel>{label}</SidebarLabel>
                </SidebarItem>
              ))}
            </SidebarSection>
          </SidebarBody>
        </Sidebar>
      }
    >
      <div className="p-6">{children}</div>
    </StackedLayout>
  );
};

export default StudentPageContainer;
